import React, { FC } from 'react';

import { Stack } from 'Modules/ui3';

import { CellProps, RowProps } from '../types';
import { CellContainer } from '../CellContainer';


export type BodyRowProps = Omit<CellProps, 'column'> & RowProps;

export const BodyRow: FC<BodyRowProps> = ({ columns, columnsWidth, isDesktop, ...props }) => (
    <Stack direction='row' justifyContent='space-between' spacing={6}>
        {columns.map(({ Cell, ...column }, index) => (
            <CellContainer
                key={`cell_${column.field}`}
                columnWidth={columnsWidth[index]}
                justifyContent={column.justifyContent}
            >
                <Cell key={column.field} column={column} {...props} />
            </CellContainer>
        ))}
    </Stack>
);
